/**
 * Utility for consistent backend URL detection across all services
 * Prevents mixed content security issues by ensuring proper protocol usage
 */

export function getBackendUrl(): string {
  // Check for explicit environment variable first
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  const host = window.location.hostname;
  
  // Determine if we're in local development
  const isLocalDevelopment = host === 'localhost' || 
                             host === '127.0.0.1' ||
                             host.startsWith('192.168.') ||
                             host.startsWith('10.') ||
                             host.startsWith('172.');
  
  // Use explicit protocol logic - always https:// in production
  const isProduction = process.env.NODE_ENV === 'production';
  const protocol = isLocalDevelopment ? 'http:' : 'https:';
  const port = isLocalDevelopment ? ':3001' : '';
  
  const url = `${protocol}//${host}${port}`;
  console.log(`🔗 Backend URL: ${url} (isLocal: ${isLocalDevelopment}, isProd: ${isProduction})`);
  return url;
}

export function getWebSocketUrl(): string {
  // Check for explicit environment variable first
  if (process.env.REACT_APP_BACKEND_WS_URL) {
    return process.env.REACT_APP_BACKEND_WS_URL;
  }

  const host = window.location.hostname;
  
  // Determine if we're in local development
  const isLocalDevelopment = host === 'localhost' || 
                             host === '127.0.0.1' ||
                             host.startsWith('192.168.') ||
                             host.startsWith('10.') ||
                             host.startsWith('172.');
  
  // Use explicit protocol logic - always wss:// in production
  const protocol = isLocalDevelopment ? 'ws:' : 'wss:';
  const port = isLocalDevelopment ? ':3001' : '';
  
  const url = `${protocol}//${host}${port}`;
  console.log(`🔗 WebSocket URL: ${url} (isLocal: ${isLocalDevelopment})`);
  return url;
}